export const SET_MODAL_STATE = 'setModalState';

export const INITIAL_REDUCER_STATE = {
  isOpen: false,
  isEditModal: false,
  collection: null,
};
